import React from "react";
import { Box } from "@mui/material";
import { useGlobalConfigs } from "@infrastructure/Hooks/useGlobalConfigs";
import { GPTContentSuggestion } from "./GPTContentSuggestion";
import { useUserUuid } from "@infrastructure/Hooks/UserInteractions/useUserId";
import { useContentGenerationForPost } from "./Hooks/useContentGenerationForPost";

function isPostEligibleForAnswerGeneration(
    storedUserId: string | undefined,
    tippspielCommentSuggestionsAuthorizedUsers: string[],
    generatedAnswersChatGptEnabled: boolean,
): boolean {
    if (!storedUserId) {
        return false;
    }

    return (
        tippspielCommentSuggestionsAuthorizedUsers.includes(storedUserId) &&
        generatedAnswersChatGptEnabled
    );
}

export function GeneratedComments({ postId }: { postId: number }) {
    const { getConfigs } = useGlobalConfigs();
    const { storedUserId } = useUserUuid();

    const tippspielCommentSuggestionsEnabled =
        getConfigs()?.tippspielCommentSuggestionsEnabled ?? false;
    const tippspielCommentSuggestionsAuthorizedUsers = (
        getConfigs()?.tippspielCommentSuggestionsAuthorizedUsers ?? ""
    ).split(",");

    const { GPTCommentSuggestionList } = useContentGenerationForPost(
        postId,
        isPostEligibleForAnswerGeneration(
            storedUserId,
            tippspielCommentSuggestionsAuthorizedUsers,
            tippspielCommentSuggestionsEnabled,
        ),
    );

    return (
        <Box>
            {GPTCommentSuggestionList?.suggestions.map((suggestion, index) => (
                <GPTContentSuggestion key={index} suggestion={suggestion} />
            ))}
        </Box>
    );
}
